import { useMemo } from 'react';

/**
 *
 * @param {*} props
 * @param {*} dispatch
 * @param {*} action
 * @param {*} state
 * @returns
 */
const useFareItemProps = (props, dispatch, action, state = undefined) => {
  const handleClick = useMemo(() => {
    return (
      action ||
      ((fare, callToActionLabel) =>
        dispatch({ type: 'FARE_CLICK', payload: { fare, callToActionLabel } }, state))
    );
  }, [action, dispatch, state]);

  return {
    ...props,
    callToActionOnClick: ({ data: fare }, callToActionLabel) => {
      handleClick(fare, callToActionLabel);
    }
  };
};

export default useFareItemProps;
